import React from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import { Images } from "../../config";

const StudentSidebar = () => {
  const location = useLocation();
  const pathname = location.pathname;

  const studentType = useSelector(
    (state) => state.profile?.user?.student?.studentType
  );

  const SidebarRoutes = [
    {
      title: "Home",
      route: "/home",
      icon: Images.SidebarHome,
    },
    {
      title: "Universities",
      route: "/universities/grid",
      icon: Images.Sidebaruniversities,
    },
    {
      title: "Shortlist",
      route: "/shortlists",
      icon: Images.Sidebarshortlist,
    },
    {
      title: "Applications",
      route: "/applications",
      icon: Images.SidebarApplications,
    },
    ...(studentType === "schoolStudent"
      ? [
          {
            title: "Meetings",
            route: "/meetings/add-meeting",
            icon: Images.Sidebarmeetings,
          },
        ]
      : []),
    {
      title: "Internships",
      route: "/internships",
      icon: Images.Sidebarcareers,
    },
    {
      title: "Profile Builder",
      route: "/profile-builder",
      icon: Images.Sidebarprofilebuilder,
    },
    {
      title: "Visa Information",
      route: "/visa-information",
      hoverTitle:
        "Provides details on visa requirements, application costs, processing time, required documents, and additional information for obtaining a student visa.",
      icon: Images.Sidebarvisainfo,
    },
    // {
    //   title: "Essay Grader",
    //   route: "/essay",
    //   icon: Images.Sidebaressaygrader,
    // },
    {
      title: "AI Recommender",
      route: "/recommender",
      icon: Images.Sidebarrecommender,
    },
    // {
    //   title: "Interactive Learning",
    //   route: "/interactive-learning",
    //   icon: Images.Sidebarinteractivelearning,
    // },
  ];

  return (
    <div className="sidebar">
      <Link to="/home">
        <img src={Images.SidebarLogo} className="sidebar-logo" />
      </Link>

      <div className="sidebar-items-container">
        {SidebarRoutes.map((item, index) => (
          <Link
            className={`${
              item?.route?.includes(pathname.split("/")[1])
                ? "sidebar-item-active"
                : "sidebar-item"
            } ${item?.comingSoon && "pointer-events-none"}`}
            to={item.route}
            key={index}
            title={item?.hoverTitle}
            onClick={(e) => {
              if (pathname === item.route) {
                e.preventDefault();
                window.location.reload();
              }
            }}
          >
            <div className="flex gap-4 items-center">
              <img
                src={item.icon}
                className={`${
                  item?.comingSoon ||
                  !item?.route?.includes(pathname.split("/")[1])
                    ? "opacity-50"
                    : "opacity-100"
                } sidebar-icon`}
              />
              <div className="sidebar-title">
                <div
                  className={`${
                    item?.comingSoon ? "opacity-50" : "opacity-100"
                  } text-ellipsis whitespace-nowrap`}
                >
                  {item?.title}
                </div>
              </div>
            </div>
          </Link>
        ))}
        <Link
          className="sidebar-item bg-visionAiBtn-gradient"
          to="/vision-ai"
          title="VisionAI"
          cla
        >
          <div className="flex gap-4 items-center ">
            <img src={Images.VisionAILogo} className="h-[2em] w-[2em]" />
            <div
              className={`text-ellipsis whitespace-nowrap text-white text-[1.2em]`}
            >
              Vision<strong>AI</strong>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};
export default StudentSidebar;
